export enum PreInfoMode {
    DECLINED = 0,
    APPROVED = 1
}